import { AxiosResponse } from 'axios'
import { API } from '../config'
import {
  BirthCertificateDto,
  CreateEarCertificateDto,
  EarringDto,
  EarTagBirthCertificateDto
} from 'src/dto/birth-certificate.dto'
import { BirthCertificateForm, UpdateBrincoForm } from 'src/@types/validations/BirthCertificate'

export interface BirthCertificateDtoParams {
  userFilter?: string
}

const BASE_URL = '/entity/Ficha'

export class BirthCertificateService {
  public async getBirthCertificateList(
    farmId: string,
    params?: BirthCertificateDtoParams
  ): Promise<AxiosResponse<BirthCertificateDto[]>> {
    return await API.get<BirthCertificateDto[]>(`/table/entity/${farmId}/ficha `, { params })
  }

  public async getEarringList(earTagBirthCertificateId: string): Promise<AxiosResponse<EarTagBirthCertificateDto[]>> {
    return API.get<EarTagBirthCertificateDto[]>(`/entity/Brinco/${earTagBirthCertificateId}`)
  }
  public async getEarringTagBirthCertificateList(fichaId: string): Promise<AxiosResponse<BirthCertificateDto[]>> {
    return API.get<BirthCertificateDto[]>(`/entity/FichaBrinco/${fichaId}`)
  }

  public async updateBirthCertificate(
    farmId: string,
    birthCertificateDto: BirthCertificateForm
  ): Promise<AxiosResponse<BirthCertificateDto>> {
    return API.put<any>(`${BASE_URL}/${farmId}`, birthCertificateDto)
  }

  public async updateEarringCertificate(
    farmId: string,
    earCertificatePayload: CreateEarCertificateDto
  ): Promise<AxiosResponse<any>> {
    return API.put<any>(`/entity/FichaBrinco/${farmId}`, earCertificatePayload)
  }

  public async updateEarring(
    farmId: string,
    earringPayload: Omit<UpdateBrincoForm, 'tempId'>
  ): Promise<AxiosResponse<EarringDto>> {
    return API.put<any>(`/entity/Brinco/${farmId}`, earringPayload)
  }
}
